<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="course">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.recording_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Grabaciones {{ course.name }} </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="px-0">
                <v-container class="py-0" fluid>
                    <v-row justify="center" align="center">
                        <v-col cols="12" class="pa-0">
                            <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-col style="position:relative; top: -60px">
                                <v-card>
                                    <v-card-title>Nuevo registro</v-card-title>
                                    <v-card-text>Dar de alta nueva grabación</v-card-text>
                                    <v-card-actions>
                                        <v-btn text block @click="new_recording_dialog = !new_recording_dialog">Nuevo registro</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                            <v-col style="position:relative; top: -60px">
                                <v-card v-if="course.recordings.length > 0">
                                    <v-card-text>
                                        <v-list dense three-line>
                                            <v-list-item-group>
                                                <template v-for="(recording, index) in course.recordings">
                                                    <v-list-item :key="index" @click="() => { watch_item = recording; watch = !watch }">
                                                        <v-list-item-avatar size="70" class="pa-0">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-img :src="video_avatar_initial+recording.name+video_avatar_final" v-bind="attrs" v-on="on"></v-img>
                                                                </template>
                                                                <span>Ver video</span>
                                                            </v-tooltip>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ recording.name }}</v-list-item-title>
                                                            <v-list-item-subtitle>{{ recording.description }}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-list-item-action-text>{{ recording.date }}</v-list-item-action-text>
                                                            <v-menu offset-y>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn icon v-bind="attrs" v-on="on">
                                                                        <v-icon>mdi-menu</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-list dense>
                                                                    <v-list-item class="px-0">
                                                                        <v-list-item-content>
                                                                            <v-btn small text>Editar</v-btn>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                    <v-list-item class="px-0">
                                                                        <v-list-item-content>
                                                                            <v-btn small text @click="() => {delete_item = recording.id; delete_recording_dialog = !delete_recording_dialog}">Eliminar</v-btn>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-list-item-action>
                                                    </v-list-item>
                                                    <v-divider v-if="index < course.recordings.length-1"></v-divider>
                                                </template>
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                                <v-card v-else outlined>
                                    <v-card-text>
                                        <p class="text-center">Sin elementos disponibles</p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <v-dialog v-model="new_recording_dialog" max-width="800" persistent>
            <v-card>
                <v-card-title>Nueva grabación</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-form ref="new_recording_form" v-on:submit.prevent="submit">
                                    <v-text-field v-model="name" :rules="[rules.required]" label="Nombre de la clase" filled color="#000"></v-text-field>
                                    <v-textarea v-model="description" :rules="[rules.required]" label="Descripción" filled color="#000"></v-textarea>
                                    <v-text-field v-model="iframe" :rules="[rules.required]" label="IFRAME" filled color="#000"></v-text-field>
                                    <v-menu ref="date_menu" v-model="date_menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="date" :rules="[rules.required]" readonly label="Fecha" filled color="#000" v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="#000" @click="date_menu = false">Cancelar</v-btn>
                                            <v-btn color="#008dd4" @click="$refs.date_menu.save(date)" dark>Seleccionar</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="new_recording_dialog = false" :disabled="loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" @click="submit" :loading="loading" dark>Registrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="watch" max-width="900" persistent>
            <v-card v-if="watch_item">
                <v-card-title>{{ watch_item.name }}</v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <span v-html="watch_item.iframe"></span>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="reset_watch">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="delete_recording_dialog" persistent max-width="400">
            <v-card>
                <v-card-title>Atención</v-card-title>
                <v-card-text>
                    <p class="text-center">¿Realmente desea eliminar el elemento?</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="delete_recording_dialog = false" :disabled="loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark @click="delete_recording" :loading="loading">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<style>
    iframe{
        width: 100% !important; 
    }
</style>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog', 'store_url','course','delete_url'],
    data: () => ({
        new_recording_dialog:false,
        delete_recording_dialog:false,
        video_avatar_initial:"https://ui-avatars.com/api/name=",
        video_avatar_final:"?background=random",

        delete_item:"",

        rules:{
            required: v => !!v || 'El campo es requerido',
        },

        loading:false,

        watch:false,
        watch_item:"",

        date_menu:false,
        date:"",
        name:"",
        description:"",
        iframe:""
    }),

    methods:{
        submit:function(){
            if(this.$refs.new_recording_form.validate()){
                this.loading = true

                let data = {}
                data.date = this.date
                data.course_id = this.course.id
                data.name = this.name
                data.description = this.description
                data.iframe = this.iframe

                axios.post(this.store_url, data).then(response => {
                    this.$refs.new_recording_form.reset()
                    this.new_recording_dialog = false
                    iziToast.success({
                        title:"Correcto",
                        message:"Grabación almacenada correctamente",
                        position:"topRight"
                    })

                    this.$parent.getItems()
                    this.$parent.recording_dialog = false

                }).catch(error => {
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }else{
                        iziToast.error({
                            title:"Error",
                            position:'topRight',
                            message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                        })
                    }
                })
                
                this.loading = false
            }
        },

        reset_watch:function(){
            this.watch_item = ""
            this.watch = false
        },

        delete_recording:function(){
            this.loading = true
            let data = {}
            data.recording_id = this.delete_item

            axios.post(this.delete_url, data).then(response => {

                iziToast.success({
                        title:"Correcto",
                        message:"Elemento eliminado correctamente",
                        position:"topRight"
                    })

                this.$parent.getItems()
                this.loading = this.delete_recording_dialog = this.$parent.recording_dialog = false

            }).catch(error => {
                this.loading = this.delete_recording_dialog = false
                iziToast.error({
                    title:"Error",
                    position:'topRight',
                    message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                })
            })
        }
    }
}
</script>